/** @flow */

import type { State } from "@store/reducers";
import type { EmployeeIdentity } from "@modules/service/reducer/employee-identity/types";

export const getEmployeeIdentityData = (state: State): EmployeeIdentity =>
  state.service.employeeIdentity.employeeIdentityData;

export const getCurrentChangeSetId = (state: State): number =>
  (state.service.employeeIdentity.changeSet || {}).id;

export const getEmployeeIdentitySchema = (state: State): ?Object =>
  state.service.employeeIdentity.schema;
